import { render, staticRenderFns } from "./luxury-homepage-content-overlay.vue?vue&type=template&id=2bf7394c&scoped=true&"
var script = {}
import style0 from "./luxury-homepage-content-overlay.vue?vue&type=style&index=0&id=2bf7394c&lang=scss&scoped=true&"
import style1 from "./luxury-homepage-content-overlay.vue?vue&type=style&index=1&id=2bf7394c&scoped=true&lang=css&"
import style2 from "./luxury-homepage-content-overlay.vue?vue&type=style&index=2&id=2bf7394c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7394c",
  null
  
)

export default component.exports